<template>
    <div>
        <v-dialog v-model="dialogOpen" max-width="600px" persistent>

            <v-card color="grey darken-3">
                <v-toolbar dense>
                    <v-toolbar-title class="title">
                        Select group
                    </v-toolbar-title>

                    <v-spacer/>

                    <v-tooltip color="primary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="close()" v-on="on" icon>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close this dialog</span>
                    </v-tooltip>

                </v-toolbar>

                <v-container fluid  class="pt-0">
                    <v-row row>

                        <v-col cols="6">
                            <div class="scrollPanel">
                                <v-list dense>
                                    <v-subheader>Recently modified</v-subheader>
                                    <v-divider/>
                                    <template v-for="(group,index) in recentGroups">
                                        <v-list-item :key="group.id" @click="select(group)">
                                            <v-list-item-action>
                                                <v-icon>mdi-star</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{group.name}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider v-if="index + 1 < recentGroups.length+1"></v-divider>
                                    </template>
                                </v-list>
                            </div>
                        </v-col>

                        <v-col cols="6">
                            <div class="scrollPanel">
                                <v-list dense>
                                    <v-subheader>All groups</v-subheader>
                                    <v-divider/>
                                    <template v-for="(group,index) in groups">
                                        <v-list-item :key="group.name" @click="select(group)">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{group.name}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider v-if="index + 1 < groups.length+1"></v-divider>
                                    </template>
                                </v-list>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    export default {

        props: {
            value: {
                type: Boolean,
                required: true
            },
            groups: {
                type: Array,
                required: true,
            },
            recentGroups: {
                type: Array,
                required: true
            }
        },

        computed: {

            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            },
            data() {
                return {
                    visible: true,
                }
            }
        },

        methods: {
            select(group) {
                this.$emit('select', group);
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>


<style scoped>
    .scrollPanel {
        height: 75vh;
        overflow-y: auto;
    }
</style>
